import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../__legacy__/models/error.model';
import { MainApiService } from '../../../../__legacy__/services/api.service';
import { IApiServiceImageUpload } from '../../../../__legacy__/services/api.service.imageUpload';

export interface IRenameAttachmentRequest {
  attachmentId: string;
  name: string;
}

export interface IRenameAttachmentService {
  renameAttachmentAsync(request: IRenameAttachmentRequest): Promise<void>;
}

export namespace IRenameAttachmentService {
  export const $: interfaces.ServiceIdentifier<IRenameAttachmentService> = Symbol('RENAME_ATTACHMENT_SERVICE');
}

@injectable()
export class RenameAttachmentService implements IRenameAttachmentService {
  constructor(@inject(IApiServiceImageUpload.$) private readonly apiServiceImageUpload: MainApiService) {}

  async renameAttachmentAsync(request: IRenameAttachmentRequest): Promise<void> {
    const result = await this.apiServiceImageUpload.postAsync('/Attachments/RenameAttachment', request);

    if (result instanceof ACDLError) {
      throw result;
    }
  }
}
